import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
import { Button, Form, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { CompleteBuyer, getCompleteBuyer, getMyTaskList, getMyTaskSingle, getOfferBuyer, getOfferSeller, ReleaseBuyer, taskReviewBuyer } from '../../../../Redux/Task/action';
import moment from 'moment';
import { IMAGE_URL } from '../../../../api';
import { Rating } from 'react-simple-star-rating';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ToasterMessage from '../../../ToasterMessage';
import loader from '../../../../assets/img/loader.gif';

const MytaskCompleted = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [tasks, setTasks] = useState([])
    const [taskrelease, setTaskRelease] = useState([])
    const [isloader, setIsloader] = useState(false);
    const [toaster, setToaster] = useState("");
    useEffect(() => {


        getMyTaskSingle(state?.data?.task_details ? state?.data?.task_details : state?.data?.id)((response) => {
            if (response && response.status) {
                setTaskRelease(response?.data?.data)
            }
        });
        getOfferSeller(state?.data?.task_details ? state?.data?.task_details : state?.data?.id)((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
    }, [state]);

    // const onReleaseBuyer = () => {
    //     var task_details = state?.data?.id;
    //     ReleaseBuyer({ task_details })((response) => {
    //         if (response && response.status) {
    //             getMyTaskSingle(state?.data?.id)((response) => {
    //                 if (response && response.status) {
    //                     setTaskRelease(response?.data?.data)
    //                 }
    //             });
    //             setStates({ showToast: !state.showToast })

    //         } else {
    //             setStates({ error: true, error_message: response?.data?.message });
    //         }
    //     });
    // }
    const [states, setStates] = useState({
        showToast: false,
        error: false,
        error_message: "",
    })
    const __toggleToast = () => {
        setStates({ showToast: !state.showToast })

    }
    const validationSchema = Yup.object().shape({
        // rating: Yup.string()
        //     .required('Required'),
        // comment: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            rating: "",
            comment: "",
        },
        validationSchema,
        onSubmit: (values) => {
            const task_details = state?.is_notification ? state?.data?.task_details : state?.data?.id
            // formData.append("cancel_reason", values.cancel_reason);
            taskReviewBuyer(rating, values?.comment, task_details)((response) => {

                if (response && response.status) {
                    setIsloader(true)
                    ReleaseBuyer({ task_details })((response) => {

                        if (response && response.status) {
                            setIsloader(false)
                            getMyTaskSingle(task_details)((response) => {
                                if (response && response.status) {
                                    setTaskRelease(response?.data?.data)
                                    setToaster("Task Success")
                                    setTimeout(() => {
                                        setToaster("")

                                    }, 2000);
                                }
                            });
                            setStates({ showToast: !state.showToast })

                        } else {
                            setStates({ error: true, error_message: response?.data?.message });
                        }
                    });
                    setIsloader(false)
                    setShow(false)
                }
                else {

                    formik.setErrors({
                        comment: response?.response?.data?.data?.errors?.comment
                    })
                }

            });
        },
    });
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [rating, setRating] = useState(0)
    // Catch Rating value
    const handleRating = (rate: number) => {
        setRating(rate)
        // other logic
    }

    const onReleasedBuyer = () => {
        const task_details = state?.is_notification ? state?.data?.task_details : state?.data?.id
        ReleaseBuyer({ task_details })((response) => {
            if (response && response.status) {
                getMyTaskSingle(task_details)((response) => {
                    if (response && response.status) {
                        setTaskRelease(response?.data?.data)
                        setShow(false);
                        setToaster("Task Success")
                        setTimeout(() => {
                            setToaster("")

                        }, 2000);
                    }
                });
                setStates({ showToast: !state.showToast })

            } else {
                setStates({ error: true, error_message: response?.data?.message });
            }
        });
    }
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            {/* <ToastContainer className="p-3" position={"top-end"}>
                <Toast bg="success" onClose={__toggleToast} show={states.showToast} animation={true} autohide={200}>

                    <Toast.Body ><span className='text-white'>Payee Created Successfully</span></Toast.Body>
                </Toast>
            </ToastContainer> */}
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-details-main">
                        <div className='col-lg-6'>
                            <div className='border-right-task'>
                                <div className='task-details-flex'>
                                    <h5>{state?.data?.title}</h5>
                                    <p>
                                        {tasks?.bid_rate ?
                                            <p>Bid rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.bid_rate).toFixed(1)}</p>
                                            :
                                            <div>
                                                <p>Chat rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.chat_rate).toFixed(1)}</p>
                                                <p>Call rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.call_rate).toFixed(1)} /{state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? 'hour' : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : tasks?.time_field == 1 ? "hour" : tasks?.time_field == 2 && "min"}</p>

                                                {/* / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field ? state?.data?.assigned_data[0]?.time_field :tasks?.time_field == 1 ? "hour" : tasks?.time_field == 2 && "min"}</p> */}

                                            </div>
                                        }
                                    </p>
                                </div>
                                <h6>Expiring on: {moment(state?.data?.date_choice).format('ll')}</h6>
                                <div className='service-desc'>
                                    <h5>Service Description</h5>
                                    <p>{state?.data?.task_status?.description ? state?.data?.task_status?.description : state?.data?.description}</p>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-6'>
                            <div className='offers'>
                                <div className='task-details-flex'>
                                    <h5>Seller Info:</h5>
                                </div>
                                <div className='offers-link'>
                                    <React.Fragment>
                                        <div className="member d-flex align-items-center">
                                            <div className="pic"><img src={IMAGE_URL + tasks?.image?.image} className="img-fluid" alt="" style={{ width: "80px" }} /></div>
                                            <div className="member-info">
                                                <div className='task_title_main'>
                                                    <h4>{tasks?.assigned_to?.full_name}</h4>
                                                </div>
                                                {tasks?.avg_rating == "" && tasks?.total_rating == "" ?
                                                    <></>
                                                    :
                                                    <span className="badge badge-light-warning">{parseFloat(tasks?.avg_rating).toFixed(1)} <i class="bi bi-star-fill"></i> ( {tasks?.total_rating} )</span>
                                                }
                                                {tasks?.bid_rate ?
                                                    <p>Bid rate: {parseFloat(tasks?.bid_rate).toFixed(1)}</p>
                                                    :
                                                    <div>
                                                        <p>Chat rate: {parseFloat(tasks?.chat_rate).toFixed(1)}</p>
                                                        <p>Call rate: {parseFloat(tasks?.call_rate).toFixed(1)} /{state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? 'hour' : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : tasks?.time_field == 1 ? "hour" : tasks?.time_field == 2 && "min"}</p>

                                                        {/* / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field ? state?.data?.assigned_data[0]?.time_field :tasks?.time_field == 1 ? "hour" : tasks?.time_field == 2 && "min"}</p> */}

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="">
                                            {taskrelease?.review_flag == false &&
                                                <div className="member-info">
                                                    <h5>Rate the Buyer</h5>
                                                    <Form onSubmit={formik.handleSubmit}>
                                                        <Rating
                                                            onClick={handleRating}
                                                            // onPointerEnter={onPointerEnter}
                                                            // onPointerLeave={onPointerLeave}
                                                            // onPointerMove={onPointerMove}
                                                            transition
                                                        /* Available Props */
                                                        />
                                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                            <Form.Label className='comments'>Enter comments:</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name='comment'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.comment && !formik.errors.comment}
                                                                isInvalid={!!formik.errors.comment}
                                                                rows={3}
                                                                value={formik.values?.comment}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.comment}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <div className='text-center'>
                                                            {isloader == true ?
                                                                <div className='loader'>
                                                                    <img src={loader} alt="" />
                                                                </div>
                                                                :
                                                                <Button className='offers-assignbtn' type="submit" variant="primary">Submit</Button>
                                                            }
                                                        </div>
                                                    </Form>
                                                </div>
                                            }
                                        </div>
                                    </React.Fragment>
                                </div>


                                <React.Fragment>
                                    {!taskrelease?.payment_released &&
                                        // <div className='ms-5 text-center'>
                                        //     <Button className='offers-assignbtn' variant="primary" onClick={() => onReleaseBuyer(taskrelease)}>Release Payment</Button>
                                        // </div>
                                        <div className='text-center'>
                                            {isloader == true ?
                                                <div className='loader'>
                                                    <img src={loader} alt="" />
                                                </div>
                                                :
                                                <Button className='offers-assignbtn' variant="primary" onClick={handleShow}>Release Payment</Button>
                                            }
                                        </div>

                                    }
                                    <Modal show={show} onHide={handleClose}>
                                        <Modal.Header closeButton>

                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form onSubmit={formik.handleSubmit}>
                                                <h6 style={{ fontSize: "16px", fontWeight: "600" }}>Rate the seller</h6>
                                                <Form.Group className="mb-3 d-grid" controlId="exampleForm.ControlTextarea1">
                                                    <Form.Label>Tap a star to set your rating</Form.Label>
                                                    <Rating
                                                        onClick={handleRating}
                                                        // onPointerEnter={onPointerEnter}
                                                        // onPointerLeave={onPointerLeave}
                                                        // onPointerMove={onPointerMove}
                                                        transition
                                                    /* Available Props */
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                    <Form.Label>Enter comments:</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        name='comment'
                                                        rows={3}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.comment && !formik.errors.comment}
                                                        isInvalid={!!formik.errors.comment}
                                                        value={formik.values?.comment}
                                                    />
                                                </Form.Group>

                                                <div className='completed-task-btn text-center'>
                                                    <Button variant="primary" className='not-now-btn btn btn-primary' onClick={() => onReleasedBuyer(state?.data?.id)}>
                                                        Not Now
                                                    </Button>
                                                    <Button type="submit" variant="primary" className='rate-now-btn btn btn-primary'>
                                                        Rate Now
                                                    </Button>
                                                </div>

                                            </Form>
                                        </Modal.Body>
                                    </Modal>
                                </React.Fragment>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default MytaskCompleted;